import { OrderStatus } from './../../../../app/data/constants/orderStatus.enum';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BusinessProfile, CustomerBusinessProfile, TermsAndConditionsRow, ConnectionData } from './misc-data';

const endpoints = {
    customers: '/v1/demand/platformclients/{platform_client_id}/customers',
    advertisers: '/v1/demand/customers/{customer_id}/advertisers',
    brands: '/v1/demand/brands?platformId={platform_client_id}&customerId={customer_id}&advertiserId={advertiser_id}',
    promotion: '/v1/converged/{platform_client_id}/promotion',
    termsAndConditions: '/v1/converged/termsandconditions',
    forgotPassword: '/users/{email}/password/reset',
    customer: '/v1/converged/customers/{customer_id}',
    creditAccount: '/v1/demand/platformClients/{sellerId}/businessProfiles/{businessProfileId}',
    connections: '/v1/converged/connections?buyer_id={buyerId}'
};

export const api = {
    getCustomers: getCustomers,
    getAdvertisers: getAdvertisers,
    getBrands: getBrands,
    getPromotion: getPromotion,
    getTermsAndConditionsData: getTermsAndConditionsData,
    getTermsAndConditionsFile: getTermsAndConditionsFile,
    acceptTermsAndConditions: acceptTermsAndConditions,
    sendForgotPasswordEmail: sendForgotPasswordEmail,
    getUserDetails: getUserDetails,
    isCreditAccountNumberApproved: isCreditAccountNumberApproved,
    patchPaymentStatus: patchPaymentStatus,
    getConnections: getConnections
};

function getPromotion(http: HttpClient, platformClientId: number): Promise<{ message: string; valid_to: string }> {
    let endpoint = environment.campaignUrl + endpoints.promotion.replace('{platform_client_id}', platformClientId.toString());
    return http.get(endpoint).toPromise().then(
        (response: { message: string; valid_to: string }) => {
            return response;
        }
    );
}

function getCustomers(http: HttpClient, platform_client_id: number): Promise<any> {
    return http.get(environment.campaignUrl + endpoints.customers.replace('{platform_client_id}', platform_client_id.toString()))
        .toPromise().then((customers: any) => {
            return customers.Result;
            //can use this to test single customer-advertiser-brand case
            // var results = Array<any>();
            // results.push(customers.Result[0]);
            // return results;
        });

}

function getAdvertisers(http: HttpClient, customer_id: number): Promise<any> {
    return http.get(environment.campaignUrl + endpoints.advertisers.replace('{customer_id}', customer_id.toString()))
        .toPromise().then((advertisers: any) => {
            return advertisers.Result;
            //can use this to test single customer-advertiser-brand case
            // var results = Array<any>();
            // results.push(advertisers.Result[0]);
            // return results;
        });
}

function getBrands(http: HttpClient, platform_client_id: number, customer_id: number, advertiser_id: number): Promise<any> {
    return http.get(environment.campaignUrl + endpoints.brands.replace('{platform_client_id}', platform_client_id.toString())
        .replace('{customer_id}', customer_id.toString()).replace('{advertiser_id}', advertiser_id.toString()))
        .toPromise().then((brands: any) => {
            return brands.Result;
            //can use this to test single customer-advertiser-brand case
            // var results = Array<any>();
            // results.push(brands.Result[0]);
            // return results;
        });
}

function getTermsAndConditionsData(http: HttpClient, is_accepted: boolean): Promise<TermsAndConditionsRow[]> {
    const endpoint: string = environment.campaignUrl + endpoints.termsAndConditions + '?termsPlatformType=MEDIACORP&isAccepted=' + is_accepted;
    return http.get(endpoint).toPromise().then((response: TermsAndConditionsRow[]) => response);
}

function getTermsAndConditionsFile(http: HttpClient, download_url: string): Promise<ArrayBuffer> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf').set('Content-Type', 'application/pdf');
    const url = download_url.split('.com')[1];
    return http.get(environment.apiUrl + url, { headers: headers, responseType: 'arraybuffer' }).toPromise();
}

function acceptTermsAndConditions(http: HttpClient, termsVersionId: number) {
    const endpoint: string = environment.campaignUrl + endpoints.termsAndConditions + '/' + termsVersionId;
    return http.patch(endpoint, { "is_accepted": true }, {
        observe: 'response'
    });
}

function sendForgotPasswordEmail(http: HttpClient, email: string): Promise<any> {
    const url = window['__tvbEnv'].SSOManagerUrl + endpoints.forgotPassword.replace('{email}', email);
    const requestHeaders: HttpHeaders = new HttpHeaders(
        {
            'SSO-App-Context': window['__tvbEnv'].appAuthorityName,
            'Skip-Auth-Interceptor': ''
        }
    );
    const params = new HttpParams().set('sendEmail', 'true').set('app', window['__tvbEnv'].appAuthorityName.toLowerCase());
    return http.post(url, null, { headers: requestHeaders, params: params }).toPromise();
}

function getUserDetails(http: HttpClient, customerId: string): Promise<CustomerBusinessProfile> {
    const endpoint = endpoints.customer.replace('{customer_id}', customerId);
    return http.get(environment.apiUrl + endpoint, {
        headers: {
            'x-embedded-modules': 'BUSINESS_PROFILE'
        }
    }).toPromise().then((resp: CustomerBusinessProfile) => resp);
}

function isCreditAccountNumberApproved(http: HttpClient, sellerId: string, businessId: string): Promise<BusinessProfile> {
    const endpoint: string = environment.campaignUrl + endpoints.creditAccount.replace('{sellerId}', sellerId).replace('{businessProfileId}', businessId);
    return http.get(endpoint).toPromise().then((response: BusinessProfile) => response);
}

function patchPaymentStatus(http: HttpClient, orderId: string, status: OrderStatus): Promise<any> {
    return http.patch(
        `${environment.apiUrl}/v1/converged/orders/${orderId}`,
        {
            status: status
        }
    ).toPromise();
}

function getConnections(http: HttpClient, buyerId: number): Promise<ConnectionData> {
    let endpoint = environment.campaignUrl + endpoints.connections.replace('{buyerId}', buyerId.toString());
    return http.get(endpoint).toPromise().then(
        (response: ConnectionData) => {
            return response;
        }
    );
}
